import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { v4 as uuidv4 } from "uuid"
import type { ModelFormConfig } from "@/interfaces/component/model-form-config.interface"
import { BaseModel } from "@/models/base.model"

export const useModelFormStore = defineStore("modelFormStore", () => {
  const modelFormConfigs: Ref<ModelFormConfig<BaseModel>[]> = ref([])

  function openForm<ModelType extends BaseModel>(modelFormConfig: ModelFormConfig<ModelType>) {
    modelFormConfigs.value.push({ ...modelFormConfig, id: uuidv4() })
  }

  function closeForm(modelUuid: string) {
    modelFormConfigs.value.splice(
      modelFormConfigs.value.findIndex((config) => config.id === modelUuid),
      1
    )
  }

  return {
    modelFormConfigs,
    openForm,
    closeForm
  }
})
